import { Component, Element, Host, Prop, Watch, h } from '@stencil/core';
import store from '../../global/store';
import { BankSearchService } from '../../services/bank-search-service';

@Component({
  tag: 'ui-bank-search',
  styleUrl: 'ui-bank-search.scss',
  shadow: false,
})
export class UiBankSearch {
  @Element() el: HTMLUiBankSearchElement;

  // 📢 If these props change, remember to also update them in ui-bank-search-light.tsx

  // Magnolia _could_ provide a URL, but currently doesn't.
  // The same URL is used for local dev, TEST, and PROD.
  @Prop() bankSearchApi =
    'https://filialfinder.union-investment.de/api/addressSearch';

  // Magnolia _will_ provide a different key for PRODUCTION. This key is for dev.
  @Prop() googleApiKey = 'AIzaSyAjA94yU4pD8rV1NYAx4nLw27lSCL14UKQ';

  @Prop() assetsUrl = './assets';

  @Watch('assetsUrl')
  onAssetsUrlChange() {
    store.state.assetsUrl = this.assetsUrl;
  }

  componentWillLoad() {
    this.checkIfSlotHasForm();

    this.onAssetsUrlChange();

    BankSearchService.init(this.el, this.bankSearchApi, this.googleApiKey);
  }

  hasForm = false;

  checkIfSlotHasForm() {
    this.hasForm = Boolean(
      ['ui-cms-webforms', 'ui-bank-search-webform'].some((element) =>
        this.el.innerHTML.includes(element)
      )
    );
  }

  render() {
    return (
      <Host>
        <style>{`
          ui-bank-search{
            --url-marker-partner: url("${store.state.assetsUrl}/marker-partner.png");
            --url-marker-partner-select: url("${store.state.assetsUrl}/marker-partner-select.png");
            --url-marker-partner-hover: url("${this.assetsUrl}/marker-partner-hover.png");
            --url-map-blurred: url("${store.state.assetsUrl}/map-blurred.jpg");
          }
        `}</style>
        {(!store.state.selectedPlaceLocation || !store.state.google) && (
          <div class="bank-search__intro-wrapper">
            <ui-bank-search-intro></ui-bank-search-intro>
          </div>
        )}
        {store.state.errorMessage && (
          <ui-bank-search-error onErrorClose={this.onErrorClose}>
            {store.state.errorMessage}
          </ui-bank-search-error>
        )}
        {store.state.selectedPlaceLocation && (
          <div class="bank-search__map-wrapper">
            <ui-bank-search-map></ui-bank-search-map>
            <ui-bank-search-map-overlay></ui-bank-search-map-overlay>
          </div>
        )}
        <ui-bank-search-bank-overlay hasForm={this.hasForm}>
          <slot />
        </ui-bank-search-bank-overlay>
      </Host>
    );
  }

  onErrorClose() {
    store.state.errorMessage = '';
  }
}
